"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceConfidenceSchema = exports.EvidenceTierTallySchema = exports.EvidenceConfidenceVerdictSchema = exports.EvidenceConfidenceVerdict = void 0;
exports.computeEvidenceConfidence = computeEvidenceConfidence;
const z = require("zod");
const evidence_vote_types_1 = require("./evidence-vote.types");
const evidence_voter_tier_1 = require("./evidence-voter-tier");
var EvidenceConfidenceVerdict;
(function (EvidenceConfidenceVerdict) {
    EvidenceConfidenceVerdict["Confirmed"] = "confirmed";
    EvidenceConfidenceVerdict["Possible"] = "possible";
    EvidenceConfidenceVerdict["Rejected"] = "rejected";
})(EvidenceConfidenceVerdict || (exports.EvidenceConfidenceVerdict = EvidenceConfidenceVerdict = {}));
exports.EvidenceConfidenceVerdictSchema = z.nativeEnum(EvidenceConfidenceVerdict);
exports.EvidenceTierTallySchema = z.object({
    tier: evidence_voter_tier_1.EvidenceVoterTierSchema,
    votesFor: z.number().int().min(0),
    votesAgainst: z.number().int().min(0),
});
exports.EvidenceConfidenceSchema = z.object({
    verdict: exports.EvidenceConfidenceVerdictSchema,
    decidedBy: evidence_voter_tier_1.EvidenceVoterTierSchema.nullable(),
    tallies: z.array(exports.EvidenceTierTallySchema),
});
const TALLIED_TIERS_DESCENDING = [
    ...evidence_voter_tier_1.DECIDING_EVIDENCE_VOTER_TIERS_DESCENDING,
    evidence_voter_tier_1.EvidenceVoterTier.Pipeline,
];
function computeEvidenceConfidence(stances) {
    const standing = stances.filter((stance) => stance.polarity !== evidence_vote_types_1.EvidenceVotePolarity.Withdrawn);
    const tallies = TALLIED_TIERS_DESCENDING.map((tier) => tallyTier(standing, tier)).filter((tally) => tally !== null);
    const decider = tallies.find((tally) => evidence_voter_tier_1.DECIDING_EVIDENCE_VOTER_TIERS_DESCENDING.includes(tally.tier) && tally.votesFor !== tally.votesAgainst);
    if (decider === undefined) {
        return { verdict: EvidenceConfidenceVerdict.Possible, decidedBy: null, tallies };
    }
    const verdict = decider.votesFor > decider.votesAgainst ? EvidenceConfidenceVerdict.Confirmed : EvidenceConfidenceVerdict.Rejected;
    return { verdict, decidedBy: decider.tier, tallies };
}
function tallyTier(standing, tier) {
    const inTier = standing.filter((stance) => stance.tier === tier);
    if (inTier.length === 0) {
        return null;
    }
    return {
        tier,
        votesFor: inTier.filter((stance) => stance.polarity === evidence_vote_types_1.EvidenceVotePolarity.For).length,
        votesAgainst: inTier.filter((stance) => stance.polarity === evidence_vote_types_1.EvidenceVotePolarity.Against).length,
    };
}
//# sourceMappingURL=evidence-confidence.js.map